export const FEATURE_NAME = '@zerops/zerops/feature/automatic-top-up-config-dialog';
